import { useEffect } from "react";
import { motion } from "framer-motion";
import SuggestedPartCard from "@/components/homepage/SuggestedPartCard";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecentParts } from "../../store/parts/partsAction";
import CardShimmer from "../../hooks/CardShimmer";

const SuggestedListingsSection = ({ variants }) => {
  const dispatch = useDispatch();
  const {
    items: suggestedParts,
    loading,
    error,
  } = useSelector((state) => state.parts);

  useEffect(() => {
    dispatch(fetchRecentParts());
  }, [dispatch]);

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  if (loading) {
    return (
      <motion.section className="py-12 bg-secondary/30" variants={variants}>
        <CardShimmer row={1} />
      </motion.section>
    );
  }

  return (
    <motion.section className="py-12 bg-secondary/30" variants={variants}>
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-2xl sm:text-3xl font-bold text-center mb-10 text-foreground"
          variants={itemVariants}
        >
          New Listings from Trusted Sellers
        </motion.h2>
        {suggestedParts.length > 0 ? (
          <motion.div
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5"
            variants={variants}
          >
            {suggestedParts.map((part) => (
              <SuggestedPartCard
                key={part.id}
                part={part}
                variants={itemVariants}
              />
            ))}
          </motion.div>
        ) : (
          <motion.p
            className="text-center text-muted-foreground py-10"
            variants={itemVariants}
          >
            No parts listed yet. Be the first to add inventory!
          </motion.p>
        )}
        <>
          {suggestedParts.length > 0 && (
            <>
              <div className="flex flex-col items-center gap-3 mt-12">
                <motion.div
                  className="text-center w-full sm:w-auto"
                  variants={itemVariants}
                >
                  <Link to="/listings" className="w-full flex justify-center">
                    <Button
                      size="lg"
                      variant="outline"
                      className="group bg-background hover:bg-accent w-64"
                    >
                      View More Listings
                      <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </Link>
                </motion.div>
              </div>
            </>
          )}
        </>
      </div>
    </motion.section>
  );
};

export default SuggestedListingsSection;
